import { lazy, Suspense } from 'react'

import { Loader, ThemeWrapper } from '@paysense-india-services/elevate-web'

import '@paysense-india-services/elevate-web/dist/common.css'
import styles from './index.module.scss'

const Snackbar = lazy(() => import('@/components/Snackbar'))

const THEME_COLORS = {
  colors: {
    'brand-color': '#00ad7d',
    'brand-light-color': '#dfebfe',
    'brand-dark-color': '#00ad7d'
  }
}

export default function LayoutContainer({ children }) {
  return (
    <ThemeWrapper theme={THEME_COLORS}>
      <Suspense
        fallback={
          <div className='ew-d-flex ew-align-items-center ew-justify-content-center ew-h-100'>
            <Loader color='brand' loadingText='Please Wait...' pageLoader size='large' />
          </div>
        }>
        <div className={`ew-h-100 ew-bg-secondary ew-d-flex ew-flex-column ${styles.layoutRoot}`}>
          {children}
        </div>
      </Suspense>
      <Snackbar />
    </ThemeWrapper>
  )
}
